import api, { api_url } from '@/lib/api'
import { InventarioArquivoRepository } from './inventario-arquivo-repository'
import { ref } from 'vue'
import { InventarioArquivo } from './inventario-arquivo'
import { StatusInventarioArquivo } from './status-inventario-arquivo'
import { InventarioArquivoSchema } from './inventario-arquivo-schema'
import z from 'zod'

export * from './inventario-arquivo'
export * from './inventario-arquivo-repository'
export * from './inventario-arquivo-schema'
export * from './status-inventario-arquivo'
export * from './tipo-inventario-arquivo'

export const inventario_arquivo_repository = new InventarioArquivoRepository(api)

//const arquivos_pendentes = ref<InventarioArquivo[]>([])

export const processando = ref<Map<string, InventarioArquivo>>(new Map())
export const event_sources: Map<string, EventSource> = new Map()

export const processarArquivo = (arquivo: InventarioArquivo) => {
    let access_token: string | null = null
    if (localStorage.getItem('access_token')) {
        access_token = localStorage.getItem('access_token');
    }

    let exists = processando.value.get(arquivo.arquivo_id)
    if (exists) {
        return
    }
    processando.value.set(arquivo.arquivo_id, arquivo)

    const event_source = new EventSource(`${api_url}/inventario-arquivos/process?arquivo_id=${arquivo.arquivo_id}&access_token=${access_token}`, {
        withCredentials: true
    })
    event_sources.set(arquivo.arquivo_id, event_source)
    event_source.addEventListener('update', (evt) => {
        const data = InventarioArquivoSchema.parse(JSON.parse(evt.data))
        processando.value.set(data.arquivo_id, data)

    })
    event_source.addEventListener('finished', (evt) => {
        const data = InventarioArquivoSchema.parse(JSON.parse(evt.data))
        processando.value.delete(data.arquivo_id)
        event_sources.delete(data.arquivo_id)        
        event_source.close()
    })
    event_source.addEventListener('failed', (evt) => {
        const data = z.object({
            arquivo: InventarioArquivoSchema,
            error: z.string(),
            file: z.string(),
            line: z.coerce.number()
        }).parse(JSON.parse(evt.data))
        processando.value.delete(data.arquivo.arquivo_id)
        event_sources.delete(data.arquivo.arquivo_id)
        event_source.close()
    })
}

export const loadArquivosPendentes = async () => {
    let arquivos = await inventario_arquivo_repository.search({
        status: StatusInventarioArquivo.PENDENTE
    })
    for (let arquivo of arquivos) {
        processarArquivo(arquivo)
    }
}
export const loadArquivosProcessando = async () => {
    let arquivos = await inventario_arquivo_repository.search({
        status: StatusInventarioArquivo.PROCESSANDO
    })
    for (let arquivo of arquivos) {
        //processando.value.set(arquivo.arquivo_id, arquivo)
        processarArquivo(arquivo)
    }
}


loadArquivosProcessando()
loadArquivosPendentes()